<template>
	<div style="background-color: #fafafa;">
		<van-nav-bar title="运输费用明细" left-text="返回" left-arrow @click-left="onClickLeft" fixed>
			<div slot="right">
				<span v-if="ediable" style="margin-right:20px;color:#1890ff;" @click="saveForm">保存</span>
				<span v-if="ediablesubmmit" style="color:#1890ff;" @click="submitForm">提交</span>
			</div>
		</van-nav-bar>
		<div class="psiDetailCont">

			<van-tabs @click="switchTab" v-model="currentIndex">
				<van-tab :title="tab.name" :key="tab.id" v-for="(tab,index) in tabs">
					<ul v-if="currentIndex === 0" >
						<li>
							<van-field-acb :readonly="!ediable" class="fieldLi" v-model="list.出车地点" dict="dict_出车地点" label="出车地点"></van-field-acb>
						</li>
						<li>
							<vant-field-date :readonly="!ediable" class="fieldLi" label="出车时间" v-model="list.出车时间" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="出车公里数" v-model="list.出车公里数" type="text" />
						</li>
						<li>
							<vant-field-date :readonly="!ediable" class="fieldLi" label="装车时间" v-model="list.装车时间" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="装车地点" v-model="list.装车地点" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="*装车数量" v-model="list.装车数量" type="text" />
						</li>
						
					</ul>
					<ul v-if="currentIndex === 1">
						<li>
							<van-field-acb :readonly="!ediable" class="fieldLi" v-model="list.到达地点" dict="dict_到达地点" label="到达地点"></van-field-acb>
						</li>
						<li>
							<vant-field-date :readonly="!ediable" class="fieldLi" label="返程时间" v-model="list.返程时间" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="到达公里数" v-model="list.到达公里数" type="text" />
						</li>
						<li>
							<vant-field-date :readonly="!ediable" class="fieldLi" label="到达时间" v-model="list.到达时间" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="卸车地点" v-model="list.卸车地点" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="卸车数量" v-model="list.卸车数量" type="text" />
						</li>
					</ul>
					<ul v-if="currentIndex === 2">
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="公司加油数量" v-model="list.公司加油数量" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="公司加油金额" v-model="list.公司加油金额" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="油卡加油数量" v-model="list.油卡加油数量" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="油卡加油金额" v-model="list.油卡加油金额" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="外加统一现金数量" v-model="list.现金加油数量" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="外加统一现金金额" v-model="list.现金加油金额" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="过路费" v-model="list.过路费" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="罚款" v-model="list.罚款" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="出车补助" v-model="list.出车补助" type="text" />
						</li>
					</ul>
					<ul v-if="currentIndex === 3">
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="关联订单" v-model="list.关联订单" type="text" />
						</li>
						<li>
							<van-field-acb :readonly="!ediable" class="fieldLi" v-model="list.司机" dict="base_staff" label="司机"></van-field-acb>
						</li>
						<li>
							<van-field-acb :readonly="!ediable" class="fieldLi" v-model="list.内部车牌号" dict="dict_内部车牌号" label="内部司机车牌号"></van-field-acb>
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="外部司机车牌号" v-model="list.外部司机车牌号" type="text" />
						</li>
						<li>
							<van-field  :readonly="!ediable" class="fieldLi" label="外部司机姓名" v-model="list.外部司机姓名" type="text" />
						</li>
						<li>
							<van-field-acb :readonly="!ediable" class="fieldLi" v-model="list.物流方式" dict="dict_物流方式" label="物流方式"></van-field-acb>
						</li>
						<li>
							<van-field-attachment class="fieldLi" :readonly="!ediable" label="泵单" v-model="list.泵单" type="text"/>
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="实付金额" v-model="list.实付金额" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="费用总额" v-model="list.费用总额" type="text" />
						</li>
						<li>
							<div style="vertical-align: middle;position: relative;margin:15px 10px 0;">
									<div style="position:relative;display:block;margin-right: 5px;margin-bottom:5px;"
											v-for="(item,i) in fileList" :key="i">
											<img src="../../../assets/file.png" style="width:20px;vertical-align: middle;" alt="" />
											<span style="font-size:14px;" @click="onAttachmentClick(item)">{{item.filename}}</span>
											<van-icon style="vertical-align: middle;margin-left:5px;" name="cross"
																@click="delImg(i)"/>
									</div>
									<div style="display:block;margin-top:15px;">
											<van-uploader :after-read="afterRead" :preview-image="false" multiple
																		preview-size="60px"/>
									</div>
							</div>
						</li>
					</ul>
					<ul v-if="currentIndex === 4">
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="出车距离" v-model="list.出车距离" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="运行时间" v-model="list.运行时间" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="油耗" v-model="list.油耗" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="盈亏数量" v-model="list.亏盈数量" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="修车费用" v-model="list.修车费用" type="text" />
						</li>
						<li>
							<van-field :readonly="!ediable" class="fieldLi" label="其他费用" v-model="list.其他费用" type="text" />
						</li>
					</ul>
				</van-tab>
			</van-tabs>
			<button type="primary" v-if="showBtn" @click="rejectForm" class="van-button btn pass van-button::before van-button--info">否决</button>
			<button type="primary" v-if="showBtn" @click="passForm" class="van-button btn van-button::before van-button--info">通过</button>
		</div>
	</div>
</template>

<script>
	import {
		Tab,
		Tabs,
		Panel,
		Button,
		Icon,
		List,
		Search,
		Popup,
		PullRefresh,
		NavBar,
		Field,
		Uploader,
		Dialog,
		ImagePreview,
		Toast
	} from 'vant';
	import barcodeService from "../../../service/barcodeService";
	import formService from '../../../service/formService';
	import {
		formatDictionary
	} from "../../../utils/dictionary";
	import VantFieldDate from '../../../components/VantFieldDate';
	import VanFieldAcb from '../../../components/VanFieldAcb';
	import VanFieldAttachment from '../../../components/VanFieldAttachment';
	import userInfo from '../../../store/userInfo';
	import {API_URL} from "../../../common/config";
	import attachmentService from "../../../service/attachmentService";
	import configService from "../../../service/configService";
	import moment from "moment";
	
	export default {
		data: function() {
			return {
				currentIndex: 0,
				tabs: [{
						name: '装车情况',
						id: 1
					},
					{
						name: '卸货情况',
						id: 2
					},
					{
						name: '运行费用',
						id: 3
					},
					{
						name: '基本信息',
						id: 4
					},
					{
						name: '情况总结',
						id: 5
					},
				],
				list: {},
				fileList: [], // 附件
				attrEdit: false,
				loading: false,
				finished: false,
				pageIndex: 0,
				refreshing: false,
				finishText: "没有更多了"
			}
		},

		components: {
			VantFieldDate,
			VanFieldAcb,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Button.name]: Button,
			[PullRefresh.name]: PullRefresh,
			[Panel.name]: Panel,
			[List.name]: List,
			[Icon.name]: Icon,
			[Toast.name]:Toast,
			[Search.name]: Search,
			[Popup.name]: Popup,
			[Field.name]: Field,
			[VantFieldDate.name]: VantFieldDate,
			[VanFieldAcb.name]: VanFieldAcb,
			[VanFieldAttachment.name]: VanFieldAttachment,
			[NavBar.name]: NavBar,
			[Uploader.name]: Uploader
		},
		computed: {
				ediable(){
					return (this.formId && (this.status == 1 || this.status ==3 || this.nextStepId == 2 || this.nextStepId == 3)) || !this.formId
				},
				ediablesubmmit(){
					return !this.formId || (this.formId && this.status == 3 || this.status == 1)
				},
				showBtn(){
					return this.formId && (this.nextStepId == 2 || this.nextStepId == 3 || this.nextStepId == 4)
				}
		},
		created: async function() {
			this.formId = this.$route.query.formId;
			this.status = this.$route.query.status;
			this.nextStepId = this.$route.query.nextStepId;
			this.wfId = this.$route.query.wfId;
			
			if(this.formId){
				this.onLoad();
			}else{
				this.list.creatorId = userInfo.state.userId;
			}
		},
		methods: {
			switchTab(index) {
				this.currentIndex = index;
			},
			async onLoad() {

				let resp = await barcodeService.getFreightDetail(this.$route.query.formId);
				this.list = resp.data.Data[0];
			
				if(this.list.attachmentIds){
					let result = await barcodeService.getfileList(this.list.attachmentIds);
					let data = result.data.Data;
					let arrAtt = [];
					for(let key in data) {
						arrAtt = this.fileList.concat(data[key])
					}
					this.fileList = arrAtt;
				}
			},
			onRefresh() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = {};
				
				this.onLoad();
			},
			openDetail(item) {
					
			},
			async afterRead(file) {
				let that = this;
					let param = new FormData();
					//通过append向form对象添加数据
					let fileData = new File([file.file], encodeURIComponent(file.file.name));
					param.append("Filedata", fileData);
					//添加请求头
					let config = {
							headers: {"Content-Type": "multipart/form-data"},
					};
					let res = await formService.uploadFile(param, config);
					if (res.data.Status === "1") {
							if (this.list.attachmentIds && this.list.attachmentIds.length > 0) {
									this.list.attachmentIds += ",";
							} else {
									this.list.attachmentIds = "";
							}
							this.list.attachmentIds += res.data.Data.uuid;
							console.log(that.fileList)
							that.fileList.push({
									url: API_URL + "/oa/common/attachment/showThumb?id=" + res.data.Data.uuid,
									uuid: res.data.Data.uuid,
									filename: res.data.Data.filename
							});
							file.index = res.data.Data.uuid;
					}
			},

			onClickLeft() {
				this.$router.push("/customized/guohuanhuanbao/freight");
			},
			async saveAndSubmit(){
				let result = await barcodeService.saveForm(this.list);
				if(result.data.Status === "1"){
					Toast.success('保存成功');
					let resp = await barcodeService.passForm(this.wfId,1);
					if(resp.data.Status === "1"){
						Toast.success('审核成功');
					}else{
						Toast.fail(resp.data.Data);
					}
				}else{
					Toast.fail(result.data.Data);
				}
			},
			async showProp(){
				Dialog.confirm({
					title: '提示',
					message: '提交后不能修改数据，是否确认提交？',
				})
					.then(() => {
// 						this.$axios.post('/psi/inventoryList/getFiscalPeriod')
// 							.then(function (res) {
// 									_this.dateTime=res.data.Data
// 									_this.getData()
// 							})
						// on confirm
						this.saveAndSubmit();
						
					})
					.catch(() => {
						// on cancel
					});
			},
			async rejectForm(){
				let resp = await barcodeService.rejectForm(this.wfId,2);
				if(resp.data.Status === "1"){
					Toast.success('否决成功');
				}else{
					Toast.fail(resp.data.Data);
				}
			},
			async passForm(){
				if(!this.list.装车数量){
					Toast.fail('装车数量未填写！');
					return;
				}
				if(!this.list.出车距离){
					Toast.fail('出车距离未填写！');
					return;
				}
				if(!this.list.运行时间){
					Toast.fail('运行时间未填写！');
					return;
				}
				if(!this.list.油耗){
					Toast.fail('油耗未填写！');
					return;
				}
				if(!this.list.亏盈数量){
					Toast.fail('盈亏数量未填写！');
					return;
				}
				this.showProp();
				
			},
			async saveForm(){
			
				let resp = await barcodeService.saveForm(this.list);
				if(resp.data.Status === "1"){
					Toast.success('保存成功');
				}else{
					Toast.fail(resp.data.Data);
				}
			},
			async submitForm(){
				
				let resp = await barcodeService.saveForm(this.list);
				if(resp.data.Status === "1"){
					Toast.success('保存成功');
					let result = await barcodeService.submitForm(resp.data.Data);
					if(result.data.Status === "1"){
						Toast.success('提交成功');
					}else{
						Toast.success(result.data.Data);
					}
				}else{
					Toast.fail('保存失败');
				}
			},
			async delImg(i) {
					const attachmentId = this.fileList[i].uuid;
					let res = await formService.deleteFile(attachmentId);
					if (res.data.Status === "1") {
							let attachmentIds = this.list.attachmentIds;
							if (attachmentIds.indexOf(attachmentId + ",") > -1) {
									attachmentIds = attachmentIds.replace(attachmentId + ",", "");
							} else {
									attachmentIds = attachmentIds.replace(attachmentId, "");
							}
							this.fileList.splice(i, 1);
							this.list.attachmentIds = attachmentIds;
					}
			},
			async onAttachmentClick(attachment) {
				
					let arr = attachment.filename.split('.');
					let extension = arr.length > 1 ? arr[arr.length - 1] : '';
					let shareResp = await attachmentService.share(attachment.uuid);
					let resp = await configService.getConfigByName('Office预览链接');
					if (resp.data.Status === "1"){
							if (resp.data.Data) {
									if (['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pdf'].indexOf(extension) > -1) {
											let url = resp.data.Data.value.replace('${uuid}', attachment.uuid);
											url = url.replace('${shareKey}', shareResp.data.Data);
											this.currentOfficePreviewUrl = url;
											this.currentOfficePreviewTitle = attachment.filename;
											this.showOfficePreview = true;
									} else if (['jpg', 'png', 'gif', 'jpeg'].indexOf(extension) > -1) {
											ImagePreview([
													API_URL + '/crm/link/file/download?key=' + shareResp.data.Data
											]);
									} else {
											Toast({
													message: '暂不支持该格式的文件，请前往PC端查看'
											});
									}
							} else {
									if (['jpg', 'png', 'gif', 'jpeg'].indexOf(extension) > -1) {
											ImagePreview([
													API_URL + '/oa/common/attachment/downloadFile?id=' + attachment.uuid
											]);
									} else {
											Toast({
													message: '暂不支持该格式的文件，请前往PC端查看'
											});
									}
							}
					}
			},
		}
	};
</script>
<style>
	.card p {
		margin: 10px 0;
	}

	.card p>span {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}

	.van-pull-refresh__head {
		display: none;
	}

	.psiDetailCont {
		width: 100%;
		margin: 0 auto;
		margin-top: 120px;
	}

	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom: 0;
		position: fixed;
		width: 100%;
	}

	.li {
		width: 20%;
		border: 1px #cccc solid;
		text-align: center;
		height: 2em;
	}

	.ul {
		display: flex;
	}

	.c_color {
		color: #00C1C9;
	}

	.data_li {
		/* 	height: 2.5em;
    display: flex;
    align-items: center;
    padding: 0.2rem; */
	}

	.data_span {
		width: 6em;
		text-align: right;
	}

	.data_input {
		flex: 1;
		border: none;
	}

	.left {
		text-align: left;
	}

	.right {
		text-align: right;
	}
	.fieldLi .van-cell__title {
		text-align: left !important;
	}
	.fieldLi .van-cell__value input {
		text-align: right !important;
	}
	.fieldLi .van-cell__value textarea {
		text-align: right !important;
	}
	.van-button--info {
			color: #fff;
			background-color: #1989fa;
			border: 1px solid #1989fa;
	}
	.btn{
		width: 40% !important;
		margin-left: 1.3em;
	}
	.pass{
		border: none;
    background-color: red;
	}
</style>
